module.exports = __webpack_public_path__ + "static/img/3.fa0ba52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/3.png
// module id = Bl6R
// module chunks = 0